/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_HindiInputs */

const en_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const fr_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const de_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi`)
};

const it_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hindi`)
};

const ru_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`хинди`)
};

const es_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hindi`)
};

const zh_cn2_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印地语`)
};

const ja_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒンディー語`)
};

const hi_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हिंदी`)
};

const pt_pt2_speechmatics_target_language_hindi = /** @type {(inputs: Speechmatics_Target_Language_HindiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hindi`)
};

/**
* | output |
* | --- |
* | "Hindi" |
*
* @param {Speechmatics_Target_Language_HindiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_hindi = /** @type {((inputs?: Speechmatics_Target_Language_HindiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_HindiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_hindi(inputs)
	if (locale === "de") return de_speechmatics_target_language_hindi(inputs)
	if (locale === "it") return it_speechmatics_target_language_hindi(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_hindi(inputs)
	if (locale === "es") return es_speechmatics_target_language_hindi(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_hindi(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_hindi(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_hindi(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_hindi(inputs)
	return en_speechmatics_target_language_hindi(inputs)
});